import { render, staticRenderFns } from "./StockProfileComponent.vue?vue&type=template&id=05765e3a&"
import script from "./StockProfileComponent.vue?vue&type=script&lang=js&"
export * from "./StockProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./StockProfileComponent.vue?vue&type=style&index=0&id=05765e3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports